import styled, { keyframes } from 'styled-components';
import { Form } from '@unform/web';

import Button from '../../components/Button';

import { shade } from 'polished';

import signInBackgroundImg from '../../assets/sign-in-background.jpg';

export const Container = styled.div`
  height: 100vh;

  display: flex;
  align-items: stretch;
`;

export const Content = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;

  width: 100%;
  max-width: 700px;
`;

const appearFromLeft = keyframes`
  from{
    opacity: 0;
    transform: translateX(-50px);
  }
  to{
    opacity: 1;
    transform: translateX(0);
  }
`;

export const AnimationContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;

  animation: ${appearFromLeft} 1s;

  form {
    margin: 80px 0;
    width: 340px;
    text-align: center;

    h1 {
      margin-bottom: 24px;
    }

    a {
      color: #f4ede8;
      display: block;
      margin-top: 24px;
      text-decoration: none;
      transition: color 0.2s;
      &:hover {
        color: ${shade(0.2, '#f4ede8')};
      }
    }
  }

  > a {
    color: #ff9000;
    display: block;
    margin-top: 24px;
    text-decoration: none;
    transition: color 0.2s;

    display: flex;
    align-items: center;

    svg {
      margin-right: 16px;
    }
    &:hover {
      color: ${shade(0.2, '#ff9000')};
    }
  }
`;

export const Background = styled.div`
  flex: 1;
  background: url(${signInBackgroundImg}) no-repeat center;
  background-size: cover;
`;

export const FacebookButton = styled(Button)`
  background: #395b99;
  color: #fff;
  max-width: 340px;
  &:hover {
    background: ${shade(0.2, '#395b99')};
  }
`;

export const GoogleButton = styled(Button)`
  background: #fff;
  max-width: 340px;
  &:hover {
    background: ${shade(0.2, '#fff')};
  }
`;

export const FormLogin = styled(Form)`
  margin: 30px 0 0 0 !important;
`;

export const ButtonContent = styled.div`
  display: flex;
  justify-content: space-around;
  align-items: center;
`;

export const ForgotPassword = styled.div`
  cursor: pointer;
  margin-top: 10px;
  &:hover {
    color: ${shade(0.2, '#fff')};
  }
`;

export const ForgotPasswordContainer = styled.div``;
